import { createKeyStoreInteractor, createWeb3ProviderEvmKeyStore } from "@chromia/ft4";
import { IClient } from "postchain-client";
import { FC, useEffect } from "react";
import { useAccount, useConnect } from "wagmi";
import { watchAccount } from '@wagmi/core';

import { dispatchChromiaBalances, dispatchClientInfo, dispatchFtToken, dispatchParams, dispatchPeriods, dispatchVaults, getClientInfo, getGtxClient, getParams, getPeriods, getVaults, updateChromiaBalances } from "../../common/utils/chromia";
import { useStoreDispatch, useStoreSelector } from "../../store/store";
import { KASapiAuth } from "../../apiMethods";
import { config } from "../..";


const WagmiWrapper: FC = () => {
	
	const { session, tokens, chrClientAddr } = useStoreSelector( store => store.app );
	const { setSession, setChrClientAddr, setClientAddr, setIsIniting, setFtoken, setAccessToken } = useStoreDispatch();
	const { connector, address } = useAccount();

	useEffect(() => {
		if (connector && !session){
			getSession();
		}
		// eslint-disable-next-line
	}, [connector, session, address])

	// useEffect(() => {
	// 	if (status === 'disconnected'){
	// 		localStorage.removeItem('WEB3_CONNECT_CACHED_PROVIDER');
	// 		setSession(null);
	// 		disconnect();
	// 		clearAppState();
	// 	}
	// 	// eslint-disable-next-line
	// }, [status])
	
	const unwatch = watchAccount(config, {
		onChange(account) { 
			if (account.address)
				getSession(account.address)
		},
	})
	
	useEffect(() => {
		unwatch()
	},[])
	
	const getSession = async (accountAddr?: string) => {
		if (!connector?.getProvider) return 
		const provider = await (connector?.getProvider());
		
		const gtx = await getGtxClient();

		if (!provider) throw new Error('missing provider');

		const interactor = await createWeb3ProviderEvmKeyStore(provider as any).then((keyStore) => { return createKeyStoreInteractor(gtx as IClient, keyStore) })

		const accs = await interactor.getAccounts();

		if (!accs[0]) {
			setChrClientAddr(null);
			setClientAddr(null);
			setIsIniting(true);
			throw new Error('no accs');
		}

		if (accountAddr) {
			setClientAddr(accountAddr)
		}
		else if (address) {
			setClientAddr(address);
		}

		try {
			const session = await interactor.getSession(accs[0].id);
			setChrClientAddr(accs[0].id.toString('hex'));
			// setIsAccount(true);
			getData();
			setSession(session);
		}
		catch(err: any) {
			throw new Error(err);
		}
		setIsIniting(true);
		
		connectKAS();
	}

	useEffect(() => {
		getData();

		const tickInterval = setInterval(() => {
			getData();
		}, 60000)
	
		return () => {
			clearInterval(tickInterval);
		}
	}, [tokens, chrClientAddr])

	async function connectKAS() {
		const authorization: any = await KASapiAuth();
		if (authorization.ok) {
				setAccessToken((await authorization.json()).access_token)
		}
	}

	async function getData() {
		try {
			const promises = await Promise.all([getParams(), getVaults(), getClientInfo(), getPeriods()]);
			const [params, vaults, clientInfo, periods] = [...promises]
			dispatchParams(params);

			if (vaults)
				dispatchVaults(vaults);
			const fToken = tokens.find(token => token.address.toLocaleLowerCase() === params.ft.toString('hex').toLocaleLowerCase());

			if (fToken) {
				setFtoken(fToken.name)
			}
	
			if (periods)
				dispatchPeriods(periods);
			if (clientInfo)
				dispatchClientInfo(clientInfo);

			const balances = await updateChromiaBalances();

			if (balances)
				dispatchChromiaBalances(balances.data);
	
			dispatchFtToken()
		}
		catch(err: any) {
			throw new Error(err);
		}
	}


	return null;
}

export default WagmiWrapper;